import { ref } from 'vue'

const toastRef = ref(null)

export default function useToast() {
  const setToastRef = (ref) => {
    toastRef.value = ref
  }

  const toast = {
    error: (message) => {
      if (toastRef.value) {
        toastRef.value.addToast(message, 'error')
      }
    },
    success: (message) => {
      if (toastRef.value) {
        toastRef.value.addToast(message, 'success')
      }
    },
    warning: (message) => {
      if (toastRef.value) {
        toastRef.value.addToast(message, 'warning')
      }
    }
  }

  return { toast, setToastRef }
}